import {
  Box, Container, FormControlLabel, Typography, styled,
} from '@material-ui/core';

import MuiButton from '@/components/Button';

export const ContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: '100vh',
});

export const FlexContainer = styled(Container)({
  flex: 1,
});

export const HeaderBox = styled(Box)({
  marginTop: 32,
  marginBottom: 40,
});

export const Title = styled(Typography)({
  marginBottom: 8,
});

export const PhoneLabel = styled(Typography)({
  fontWeight: 700,
  marginBottom: 8,
});

export const RequiredConsentLabel = styled(FormControlLabel)({
  marginTop: 12,
  marginBottom: 4,
  alignItems: 'flex-start',
});

export const OptionalConsentLabel = styled(FormControlLabel)({
  marginTop: 4,
  marginBottom: 24,
  alignItems: 'flex-start',
});

export const DividerContainer = styled(Box)({
  position: 'relative',
  marginBottom: 24,
});

export const DividerText = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: theme.palette.common.white,
  padding: '0 16px',
  color: theme.palette.text.primary,
  fontSize: 14,
}));

export const continueButtonStyles = {
  marginBottom: 24,
  borderRadius: 100,
};

/**
 * A primary button whose disabled state is actually readable.
 *
 * The shared button greys out to a mid-grey fill with a white label, which measures
 * about 2.8:1 — below the 4.5:1 that normal text needs to be legible. That matters
 * more here than almost anywhere else, because disabled *is* the starting state of
 * every password and email screen in this flow: it is the first thing a member sees,
 * and on several screens the button is the only thing telling them what to do next.
 *
 * A lighter fill with dark text, both already defined in the theme, measures about
 * 4.5:1 and clears the bar.
 *
 * **Scoped here on purpose.** The same disabled style lives on the shared button used
 * by every product on the portal, and fixing it there would change screens well
 * outside this work. The shared component keeps its current contrast; whether to
 * raise it everywhere is a decision for the people who own those products, and it is
 * flagged rather than taken here.
 */
export const AccessibleButton = styled(MuiButton)(({ theme }) => ({
  // Doubled selector on purpose. The shared button sets its own disabled colours at
  // exactly the same specificity, so a single `&` ties and the winner is whichever
  // stylesheet the bundler happens to inject first — meaning the fix would apply on
  // some loads and not others. `&&` raises specificity so this always wins.
  '&&:disabled': {
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.grey[700],
  },
}));
